/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   isValidDimensions
 */

import { isNumber } from '@zcode/utils'

import type { Dimensions } from '../../types'
export const isValidDimensions = (dimensions: Dimensions | undefined) => {
  const { height, width } = dimensions || {}

  return !!height && !!width && isNumber(height) && isNumber(width)
}
